import OrganizationEditionPage from '@/pages/admin/OrganizationEditionPage/OrganizationEditionPage.vue'

export default OrganizationEditionPage
